var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01876 9.34938L0.937627 7.29386V2.69354L4.05153 0.857147V2.22234L2.33945 3.29387C2.24901 3.35099 2.19374 3.4497 2.19374 3.55648V6.41043C2.19374 6.52838 2.26094 6.63576 2.36834 6.68852L4.84476 7.90162C4.93271 7.94509 5.03757 7.94386 5.12614 7.89976L7.06995 6.92195L8.37571 8.00967L5.01876 9.34938ZM7.3149 6.31481C7.21943 6.23471 7.0819 6.21981 6.97009 6.27567L4.98167 7.27581L2.82179 6.21795V3.72659L4.53324 2.65505C4.62433 2.59793 4.67957 2.49922 4.67957 2.39244V0.310823C4.67957 0.199075 4.61867 0.096018 4.52071 0.0407656C4.42148 -0.0151058 4.30024 -0.0132439 4.20476 0.0444895L0.462818 2.25028C0.36798 2.30615 0.30957 2.40734 0.30957 2.51723V7.48381C0.30957 7.60052 0.375518 7.70728 0.481027 7.76009L4.86109 9.96648C4.90505 9.98881 4.95405 10 5.00367 10C5.04324 10 5.08281 9.99257 5.12109 9.97767L9.09481 8.39271C9.19657 8.35171 9.27005 8.2611 9.28762 8.15305C9.30462 8.04567 9.26376 7.937 9.17962 7.86686L7.3149 6.31481Z",
    fill: "url(#paint0_linear_13118_149824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06219 6.27557L7.83814 5.3251V3.55701C7.83814 3.44961 7.78224 3.34966 7.6899 3.29316L5.93762 2.21976V0.855196L9.06219 2.68414V6.27557ZM9.53638 2.24025L5.78376 0.0431575C5.68705 -0.0133378 5.56581 -0.0145759 5.46786 0.0406764C5.37048 0.0959288 5.30957 0.198367 5.30957 0.310115V2.39235C5.30957 2.49975 5.36609 2.59971 5.45781 2.6562L7.21005 3.7296V5.47595C7.21005 5.57095 7.25467 5.661 7.33067 5.71995L9.18219 7.15905C9.23871 7.2031 9.30652 7.22548 9.37624 7.22548C9.42271 7.22548 9.46981 7.21491 9.51314 7.19381C9.62119 7.14229 9.69028 7.03362 9.69028 6.91505V2.50721C9.69028 2.39732 9.63186 2.2955 9.53638 2.24025Z",
    fill: "url(#paint1_linear_13118_149824)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13118_149824",
    x1: 5.78029,
    y1: 2.38095,
    x2: 0.393314,
    y2: 4.93829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26113,
    stopColor: "#F7981D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696918,
    stopColor: "#F37731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1623E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13118_149824",
    x1: 5.78028,
    y1: 2.38095,
    x2: 0.393313,
    y2: 4.93829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26113,
    stopColor: "#F7981D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696918,
    stopColor: "#F37731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1623E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsc);
export default __webpack_public_path__ + "static/media/ESC.743ec3e35736a1f0ba922964a64bf211.svg";
export { ForwardRef as ReactComponent };